<template>
<div>

    <div class="risk-circle" v-if="isHigh">
        <svg class="risk-circle__svg" width="169" height="169" viewBox="0 0 120 120">
            <circle cx="60" cy="60" r="54" fill="none" stroke="#eee" stroke-width="4" />
            <circle class="risk-circle__progress--high" cx="60" cy="60" r="54" fill="none" stroke="#e74f52" stroke-width="4" stroke-dasharray="339.292" stroke-dashoffset="0" />
        </svg>
        <div class="risk-circle__text">High</div>
    </div>

    <div class="risk-circle" v-else-if="isModerate">
        <svg class="risk-circle__svg" width="169" height="169" viewBox="0 0 120 120">
            <circle cx="60" cy="60" r="54" fill="none" stroke="#eee" stroke-width="4" />
            <circle class="risk-circle__progress--medium" cx="60" cy="60" r="54" fill="none" stroke="#E0DA1C" stroke-width="4" stroke-dasharray="339.292" stroke-dashoffset="118.752" />
        </svg>
        <div class="risk-circle__text">Moderate</div>
    </div>

    <div class="risk-circle" v-else>
        <svg class="risk-circle__svg" width="169" height="169" viewBox="0 0 120 120">
            <circle cx="60" cy="60" r="54" fill="none" stroke="#eee" stroke-width="4" />
            <circle class="risk-circle__progress--low" cx="60" cy="60" r="54" fill="none" stroke="#A5D535" stroke-width="4" stroke-dasharray="339.292" stroke-dashoffset="227.326" />
        </svg>
        <div class="risk-circle__text">Low</div>
    </div>

</div>
</template>

<script>
    export default {
        name: "UXRiskCircle",
        props: {
            isModerate: Boolean,
            isHigh: Boolean
        },
        computed: {}
    };
</script>
